import { useTranslation } from "react-i18next";

import { useDiscountValidation } from "./useDiscountValidation";
import DiscountGiftcardInput from "./DiscountGiftcardInput";
import { useAppSelector } from "store/app";

interface IDiscountProps {
  discountInstanceId: string;
}

export default function Discount(props: IDiscountProps) {
  const { discountInstanceId } = props;
  
  const { isFasttrack } = useAppSelector();
  const { t } = useTranslation();

  const { discountCode, amount, validationIsLoading, errorMessageKey, handleDiscountValidation, resetDiscountSession } = useDiscountValidation(discountInstanceId);

  const placeholder = t(`checkout:Discount.${isFasttrack ? 'Title' : 'Input'}`);

  return (
    <div className="discount-container">
      <DiscountGiftcardInput validatedCode={discountCode} validatedAmount={amount} validationIsLoading={validationIsLoading} errorMessageKey={errorMessageKey} placeholder={placeholder} handleValidation={handleDiscountValidation} resetSession={resetDiscountSession} />
    </div>
  );
}
